import { render } from "./platform.html?vue&type=template&id=07fae3ed&scoped=true&lang=html&external"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"

import "./_platform.mobile.scss?vue&type=style&index=0&id=07fae3ed&lang=scss&scoped=true&external"
import "./_platform.desktop.scss?vue&type=style&index=1&id=07fae3ed&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fae3ed"]])

export default __exports__